import { Page } from '@/components/ui';
import { Order } from '@/pages/Order';
import { Redeem } from '@/pages/Redeem';
import { Thanks } from '@/pages/Thanks';
import type { JSX } from 'preact';
import { render } from 'preact';
import { LocationProvider, Route, Router } from 'preact-iso';
import './style.css';

function Home(): JSX.Element {
  // The marketing page lives on betteroo.ai/gifting; the bare root just goes to the order form.
  window.location.replace('/order');
  return <Page>{null}</Page>;
}

function NotFound(): JSX.Element {
  return (
    <Page>
      <div className="space-y-3 text-center">
        <h1 className="font-heading text-2xl font-bold">Page not found</h1>
        <a href="/order" className="text-brand-orange underline">Give Betteroo as a gift</a>
      </div>
    </Page>
  );
}

function EmbeddedOrder(): JSX.Element {
  return <Order embedded />;
}

export function App(): JSX.Element {
  return (
    <LocationProvider>
      <Router>
        <Route path="/" component={Home} />
        <Route path="/order" component={Order} />
        <Route path="/embed/order" component={EmbeddedOrder} />
        <Route path="/thanks" component={Thanks} />
        <Route path="/redeem" component={Redeem} />
        <Route default component={NotFound} />
      </Router>
    </LocationProvider>
  );
}

const root = document.getElementById('app');
if (root) render(<App />, root);
